import branding from "../mixins/branding";

export default{
    mixins: [branding],
    methods:{
        data(){
            return {
                imageErrorUrls:[]
            }
        },
        imageUrl(url){
            return (this.imageErrorUrls.includes(url) || url.length ==0) ? this.brandingImagesPath("/images/vehicle-listing/awaiting-img.jpg") : url.replace('gmvrldev','gmvrl');
        },
        imageLoadFailed(url){
            this.imageErrorUrls.push(url);
        },
    }
}